import React from 'react';
import {
  ActivityIndicator,
  Platform,
  StyleSheet,
  View,
  TouchableNativeFeedback,
  TouchableOpacity,
  StyleProp,
  ViewStyle,
  ButtonProps,
  TouchableWithoutFeedbackProps,
  TextStyle
} from 'react-native';

import Icon from 'react-native-vector-icons/MaterialCommunityIcons';
import Text from './Text';
import fontMaker from '../../utils/font';

export type AppButtonProps = {
  title: string;
  style?: StyleProp<ViewStyle>;
  icon?: string;
  backgroundColor?: string;
  fontSize?: number;
  color?: string;
  onPress?: (event?: any) => any;
  disabled?: boolean;
  loading?: boolean;
  accessibilityLabel?: string;
  testID?: string;
  underlayColor?: string;
} & ButtonProps;

export const AppButton: React.FunctionComponent<AppButtonProps> = props => {
  const {
    accessibilityLabel,
    backgroundColor,
    fontSize,
    color,
    onPress,
    title,
    disabled,
    loading,
    testID,
    style,
    icon
  } = props;
  const buttonStyles: any = [styles.button];
  const textStyles: any = [styles.text];
  if (style) {
    buttonStyles.push(style);
  }
  if (backgroundColor) {
    buttonStyles.push({ backgroundColor });
  }
  if (fontSize) {
    textStyles.push({ fontSize });
    if (fontSize < 14) {
      textStyles.push({ paddingVertical: 4 });
    }
  }
  if (color) {
    textStyles.push({ color });
  }
  const accessibilityStates: any = [];
  if (disabled) {
    buttonStyles.push(styles.buttonDisabled);
    textStyles.push(styles.textDisabled);
    accessibilityStates.push('disabled');
  }
  const Touchable: React.ComponentClass<TouchableWithoutFeedbackProps> =
    Platform.OS === 'android' ? TouchableNativeFeedback : TouchableOpacity;

  return (
    <Touchable
      accessibilityRole="button"
      accessibilityLabel={accessibilityLabel}
      accessibilityStates={accessibilityStates}
      testID={testID}
      disabled={disabled || loading}
      onPress={onPress}
    >
      <View style={[buttonStyles]}>
        {loading ? (
          <ActivityIndicator animating={loading} color={color || '#ffffff'} size="small" style={styles.loader} />
        ) : null}
        {icon ? <Icon name={icon} size={16} color="white" /> : null}
        <Text allowFontScaling={false} style={textStyles}>
          {title}
        </Text>
      </View>
    </Touchable>
  );
};

export default AppButton;

const styles = StyleSheet.create({
  button: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 56,
    paddingVertical: 8,
    borderRadius: 12,
    backgroundColor: '#16A34A',
    shadowColor: '#16A34A',
    shadowOffset: { width: 0, height: 8 },
    shadowOpacity: 0.18,
    shadowRadius: 18,
    elevation: 6
  },
  text: {
    ...fontMaker({ weight: 'SemiBold' }),
    textAlign: 'center',
    color: '#fff',
    padding: 8,
    fontSize: 16
  },
  buttonDisabled: {
    elevation: 0,
    shadowOpacity: 0,
    backgroundColor: '#E5E7EB',
    borderColor: '#E5E7EB'
  },
  loader: {
    marginRight: 8
  },
  textDisabled: {
    color: '#98A2B3'
  }
});
